import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';

import { KendoService } from './services/kendo.service';

export function provideKendo(): EnvironmentProviders {
  return makeEnvironmentProviders([
    KendoService,
    { provide: ICON_SETTINGS, useValue: { type: 'font' } },
  ]);
}
